import { GitPullRequestArrow, SlidersHorizontal } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const changeControlNav: NavEntry = {
  label: 'Change control',
  icon: GitPullRequestArrow,
  path: '/quality/changes',
  permission: 'change:read',
  order: 17,
}
export const changeControlSettingsNav: NavEntry = {
  label: 'Change approvals',
  icon: SlidersHorizontal,
  path: '/settings/change-control',
  permission: 'settings:read',
  order: 86,
}
